export default {
  getUploadedUserImageAssetPath(path) {
    // var base_path = window.location.pathname;
    // if (window.env === 'dev') {}
    let base_path = 'https://script.moviestart.ru';
    if (path.length === 0) {
      path = base_path+'/images/anonym.png';
    } else {
      path = base_path+'/uploads/images/'+path;
    }
    return path;
  },
  getUserRoleLabelByRole(role) {
    switch (role) {
      case 'ROLE_ADMIN':
        return 'Администратор';
      case 'ROLE_ORGANIZATOR':
        return 'Организатор';
      case 'ROLE_PARTICIPANT':
        return 'Участник';
      case 'ROLE_EXPERT':
        return 'Эксперт';
      case 'ROLE_AREA':
        return 'Площадка';
      case 'ROLE_COMISSION':
        return 'Кинокомиссия';
      default:
        return 'Пользователь';
    }
  },
  hasRole(role, user) {
    return user.roles.includes(role);
  }
}